import "core-js/modules/es.object.freeze.js";
export var KEYCODE = Object.freeze({
  TAB: 9,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  ENTER: 13
});